export * as alarms from '@wix/auto_sdk_motion_alarms/schemas';
export * as metroinspector from '@wix/auto_sdk_motion_metroinspector/schemas';
export * as products from '@wix/auto_sdk_motion_products/schemas';
